export default __webpack_public_path__ + "static/media/uploader-medtronic-problem-1.5a7a424d.png";